import React, {useCallback, useEffect, useMemo, useRef, useState} from 'react';
import styled from "styled-components";
import LlmChampionCounter from "./llmChampionCounter";
import LlmChampionCompare from "./llmChampionCompare";
import LlmTextBox from "./llmTextBox";
import useLLMText from "../../common/hooks/llm/useLLMText";
import {CopyToClipboard} from "react-copy-to-clipboard";
import {ImageLane} from "../common";
import {llmPositionNameSupporter} from "../../function";
import {useTranslation} from "react-i18next";
import useChampionFunc from "../../common/hooks/useChampionFunc";
import {useLocation} from "react-router-dom";
import useLLMTips from "../../common/hooks/llm/useLLMTips";

const Wrapper = styled.div`
  padding: 32px 20px;
`;

const ChampionInfoWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 24px;
`;

const LlmCompare = ({
                        pickChampion,
                        againstChampion,
                        onChangeAgainstChampion,
                        pickChampionBuild,
                        againstChampionBuild,
                        inputAgainstChampion,
                        inputPickChampion,
                        onChangeInputAgainstChampion,
                        onChangeInputPickChampion,
                        onChangePickChampion,
                        position,
                        setPosition,
                    }) => {
    const llmText = useLLMText({
        enemy_champion_id: againstChampion?.champion_id,
        champion_id: pickChampion?.champion_id
    })
    const llmTips = useLLMTips({
        enemy_champion_id: againstChampion?.champion_id,
        champion_id: pickChampion?.champion_id
    })
    const location = useLocation();
    const search = new URLSearchParams(location.search)
    const onClickChange = () => {
        const copyPick = inputPickChampion
        const copyAgainst = inputAgainstChampion
        onChangeInputAgainstChampion({target: {value: copyPick}})
        onChangeInputPickChampion({target: {value: copyAgainst}})
    }

    useEffect(() => {
        if (Array.isArray(llmText.data.text) && !search.get('position')) {
            if (llmText?.data?.text[0]?.position) {
                setPosition(llmText.data.text[0].position)
            }
        }
    }, [llmText.data.text]);

    const getCompareData = useMemo(() => {
        try {
            const findData = llmText.data.text.find((item) => item.position.toLowerCase() === position.toLowerCase());
            if (findData) {
                return findData
            }
            return undefined
        } catch (e) {
            return undefined
        }
    }, [position, llmText?.data?.text]);

    return (
        <Wrapper>
            <ChampionSearchBox onChangePickChampion={onChangeInputPickChampion} pickChampion={inputPickChampion}
                               onChangeAgainstChampion={onChangeInputAgainstChampion} onClickChange={onClickChange}
                               againstChampion={inputAgainstChampion}
                               data={llmText.data.text}
                               position={position}
                               setPosition={setPosition}
            />
            <ChampionInfoWrapper>
                <LlmChampionCounter champion={pickChampion} championBuild={pickChampionBuild}
                                    onChangeChampion={onChangeAgainstChampion} position={position}/>
                <LlmChampionCompare pickChampion={pickChampion} againstChampion={againstChampion}
                                    data={getCompareData}/>
                <LlmChampionCounter champion={againstChampion} reverse={true}
                                    championBuild={againstChampionBuild} onChangeChampion={onChangePickChampion}
                                    position={position}/>
            </ChampionInfoWrapper>
            <LlmTextBox list={llmTips.data.tips}/>
        </Wrapper>
    );
};


const SearchBoxWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  background-color: ${props => props.theme.color.site_main_color};
`;
const SearchInput = styled.div`
  background-color: #fff;
  width: 224px;
  height: 40px;
  display: flex;
  flex-direction: row;
  border-radius: 4px;
  align-items: center;
  overflow: hidden;
  padding: 0 10px;
  border: 1px solid ${props => props.theme.color.default_border_color};

  input {
    border: 0;
    width: 200px;
    color: #353535;

  }
;

  input::placeholder {
    color: ${props => props.theme.color.dark_200};
    opacity: 1;
  }
`;
const CloseButton = styled.button`
  height: 100%;
`;
const ChangeButton = styled.button`
  margin: 0 16px;
  width: 120px;
  height: 40px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 10px 14px;
  border: 2px solid ${props => props.theme.color.green_100};
  border-radius: 4px;
  background-color: ${props => props.theme.color.green_200};

  &:hover {
    background-color: ${props => props.theme.color.default_border_color};
  }
`;

const ChangeButtonSpan = styled.span`
  font-weight: 700;
  font-size: 16px;
  color: ${props => props.theme.color.green_100};

`;

const Rotate180 = styled.div`
  rotate: 180deg;
`;


const InputBoxWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;

const ResetButton = styled.button`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  border: 2px solid ${props => props.theme.color.default_border_color};
  height: 40px;
  width: 96px;
  font-weight: 700;
  font-size: 16px;
  border-radius: 4px;

  background-color: ${props => props.theme.color.site_main_color};
  color: ${props => props.theme.color.dark_200};


  &:hover {
    background-color: ${props => props.theme.color.gray_200};
    color: ${props => props.theme.color.dark_300};
  }
`;

const ShareButton = styled.button`
  position: relative;
  width: 96px;
  height: 40px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  font-weight: 700;
  font-size: 16px;
  background-color: ${props => props.theme.color.site_main_color};
  color: ${props => props.theme.color.dark_200};
  border: 2px solid ${props => props.theme.color.default_border_color};
  border-radius: 4px;

  &:hover {
    background-color: ${props => props.theme.color.gray_200};
    color: ${props => props.theme.color.dark_300};
  }


`;

const SearchBoxBorderWrapper = styled.div`
  padding-bottom: 16px;
  border-bottom: 1px solid ${props => props.theme.color.default_border_color};
  background-color: ${props => props.theme.color.site_main_color};
`;

const PositionBox = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  height: 40px;
  margin-top: 16px;
  gap: 16px;
`;

const LaneBox = styled.button`
  .imgLane {
    width: 24px;
    height: 24px;
  }

  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 96px;
  height: 40px;
  background-color: ${props => {
    let color = props.theme.color.site_main_color
    if (props.selected) {
      color = props.theme.color.green_200
    }
    return color;
  }};
  border: 2px solid ${props => {
    let border = props.theme.color.default_border_color
    if (props.selected) {
      border = props.theme.color.green_100
    }
    return border
  }};
  color: ${props => {
    let color = props.theme.color.dark_200
    if (props.selected) {
      color = props.theme.color.green_100
    }
    return color
  }};
  border-radius: 4px;

  &:hover {
    background-color: ${props => {
      let color = props.theme.color.white_200
      if (props.selected) {
        color = props.theme.color.green_200
      }
      return color;
    }};
  }
`;

const LaneBoxSpan = styled.span`
  font-weight: 600;
  font-size: 16px;

  margin-left: 12px;
`;

const ChampionSearchBox = ({
                               onChangeAgainstChampion,
                               onChangePickChampion,
                               againstChampion,
                               pickChampion,
                               onClickChange,
                               data,
                               position,
                               setPosition,

                           }) => {

    const {t} = useTranslation()
    const onClickReset = () => {
        onChangeAgainstChampion({target: {value: ""}})
        onChangePickChampion({target: {value: ""}})
    }


    const positionList = useMemo(() => {
        if (Array.isArray(data)) {
            return data
        }
        return []
    }, [data])

    const getLaneName = useCallback((lane) => {
        switch (lane.toLowerCase()) {
            case 'top':
                return t('llm.top')
            case 'jungle':
                return t('llm.jungle')
            case 'middle':
                return t('llm.mid')
            case 'bot':
                return t('llm.bot')
            case 'supporter':
                return t('llm.support')
            default:
                break;
        }
    }, [])


    const stickyRef = useRef();
    const [fixed, setFixed] = useState(false);
    const [top, setTop] = useState(0);

    useEffect(() => {
        const handleScroll = () => {
            if (!stickyRef.current) return;

            const offsetTop = stickyRef.current.offsetTop + 70; // 원래 위치
            const scrollY = window.scrollY;

            console.log()
            if (scrollY >= offsetTop) {
                setFixed(true);
                setTop(0); // 화면 상단에 고정
            } else {
                setFixed(false);
            }
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);


    return (
            <SearchBoxBorderWrapper>
                <SearchBoxWrapper
                    style={{
                        visibility:fixed ? 'hidden' : 'visible'
                    }}
                >
                    <ResetButton onClick={onClickReset}>
                        {t('llm.reset')}
                    </ResetButton>
                    <InputBoxWrapper>

                        <SearchChampion placeHolder={t('llm.placeHolder')} value={pickChampion}
                                        setter={onChangePickChampion}/>

                        <ChangeButton onClick={onClickChange} tabIndex={-1}>
                            <img src={'/images/icon_change.svg'} width={4} height={18} alt={''} tabIndex={-1}/>
                            <ChangeButtonSpan tabIndex={-1}>{t('llm.swap')}</ChangeButtonSpan>
                            <Rotate180 tabIndex={-1}>
                                <img src={'/images/icon_change.svg'} width={4} height={18} alt={''} tabIndex={-1}/>
                            </Rotate180>
                        </ChangeButton>

                        <SearchChampion placeHolder={t('llm.placeHolder')} value={againstChampion}
                                        setter={onChangeAgainstChampion}/>

                    </InputBoxWrapper>
                    <ChampionShare inputChampion={pickChampion} inputAgainst={againstChampion} position={position}/>
                </SearchBoxWrapper>
                <PositionBox ref={stickyRef}>
                    {positionList.map((item, index) => {
                        return (
                            <LaneBox selected={position?.toLowerCase() === item?.position?.toLowerCase()}
                                     onClick={() => setPosition(item.position)} key={index}>
                                <ImageLane color={'gray'} lane={llmPositionNameSupporter(item.position)}/>
                                <LaneBoxSpan>{getLaneName(item.position)}</LaneBoxSpan>
                            </LaneBox>
                        )
                    })}
                </PositionBox>
            </SearchBoxBorderWrapper>
    )
}

const AbsoluteShareText = styled.div`
  position: absolute;
  right: 0;
  top: 56px;
  background-color: ${props => props.theme.color.site_background_color};
  height: 40px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 0 23.5px;
  border-radius: 8px;
  font-weight: 500;
  font-size: 14px;
  color: ${props => props.theme.color.green_100};
  white-space: nowrap;
`;
const ChampionShare = ({inputChampion, inputAgainst, position}) => {
    const {t} = useTranslation();
    const {getChampionByName, getChampion} = useChampionFunc();
    const [copy, setCopy] = useState(false);

    const handleCopy = () => {
        setCopy(true);
        closeCopied();
    };

    // 공유하기 툴팁
    const closeCopied = () => {
        setTimeout(() => {
            setCopy(false);
        }, 2000);
    };

    const urlMemo = useMemo(() => {
        const url = new URL(`${window.location.origin}/llm`);
        try {
            url.searchParams.set('champion', getChampionByName(inputChampion).champion_id);
            url.searchParams.set('enemy', getChampionByName(inputAgainst).champion_id);
            url.searchParams.set('position', position.toLowerCase())
            return url.toString()
        } catch (e) {
            return url.toString()
        }
    }, [inputChampion, inputAgainst, position]);


    return (
        <CopyToClipboard onCopy={handleCopy} text={urlMemo}>
            <ShareButton>
                {t('llm.share')}
                {copy &&
                    <AbsoluteShareText>
                        {t('multi.clipboard')}
                    </AbsoluteShareText>}
            </ShareButton>
        </CopyToClipboard>
    )
}


const SearchChampion = ({placeHolder, setter, value}) => {


    return (
        <SearchInput>
            <input
                value={value}
                autoComplete={'off'}
                placeholder={placeHolder}
                onChange={setter}
                onFocus={() => setter({target: {value: ""}})}

            />
            {value.length > 0 &&
                <CloseButton onClick={() => setter({target: {value: ''}})} tabIndex={-1}>
                    <img src={'/images/icon_close.png'} width={16} height={16} alt={''}/>
                </CloseButton>}
        </SearchInput>
    )
}

export default LlmCompare;